import type {
  ProductsFilters,
  Pagination,
} from '@app/pages/Warehouses/Products/types';

export const WAREHOUSE_ID_SEARCH_PARAM = 'warehouseId';

const numberOrUndefined = (value: string | null) =>
  value != null && value !== '' && !Number.isNaN(+value) ? +value : undefined;

export const getWarehouseIdFromSearchParams = (
  params: URLSearchParams
): number | null => {
  const warehouseId = Number(params.get(WAREHOUSE_ID_SEARCH_PARAM));

  if (!Number.isInteger(warehouseId) || warehouseId <= 0) {
    return null;
  }

  return warehouseId;
};

export const objectToSearchParams = (
  filters: ProductsFilters,
  pagination: Pagination,
  SearchId: number | null = null
) => {
  const params = new URLSearchParams();

  if (filters.SearchTerm) params.set('q', filters.SearchTerm);

  if (filters.CategoryIds?.length)
    params.set('categories', filters.CategoryIds.join(','));

  if (filters.BrandIds?.length)
    params.set('brands', filters.BrandIds.join(','));

  if (filters.PriceOfPurchaseS != null)
    params.set('ppS', String(filters.PriceOfPurchaseS));
  if (filters.PriceOfPurchaseE != null)
    params.set('ppE', String(filters.PriceOfPurchaseE));

  if (filters.PriceOfSaleS != null)
    params.set('psS', String(filters.PriceOfSaleS));
  if (filters.PriceOfSaleE != null)
    params.set('psE', String(filters.PriceOfSaleE));

  if (SearchId != null) {
    params.set('searchId', String(SearchId));
  }
  // --- пагинация
  params.set('ipp', String(pagination.ItemsPerPage));
  params.set('p', String(pagination.PageN));

  return params;
};

export const searchParamsToObject = (
  params: URLSearchParams
): { filters: ProductsFilters; pagination: Pagination } => {
  const filters: ProductsFilters = {
    WarehouseId: numberOrUndefined(params.get('wid')) ?? 0,
    SearchTerm: params.get('q') ?? null,
    CategoryIds: params.get('categories')
      ? params
          .get('categories')!
          .split(',')
          .map((n) => +n)
      : null,
    BrandIds: params.get('brands')
      ? params
          .get('brands')!
          .split(',')
          .map((n) => +n)
      : null,
    PriceOfPurchaseS: numberOrUndefined(params.get('ppS')) ?? null,
    PriceOfPurchaseE: numberOrUndefined(params.get('ppE')) ?? null,
    PriceOfSaleS: numberOrUndefined(params.get('psS')) ?? null,
    PriceOfSaleE: numberOrUndefined(params.get('psE')) ?? null,
  };

  const pagination: Pagination = {
    ItemsPerPage: numberOrUndefined(params.get('ipp')) ?? 10,
    PageN: numberOrUndefined(params.get('p')) ?? 1,
    Total: 0,
  };

  return { filters, pagination };
};
